module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEFISH.7874bf16.jpg";